import React from "react";
import PropTypes from "prop-types";
import {
  InterviewStatusWrapper,
  Status,
  LastChange,
} from "./styles/interview-status-styles";

const decorateJobStatus = (jobStatus, interviewConfirmed) => {
  if (["Pending", "Unsuccessful", "Added To Favourites"].includes(jobStatus)) {
    return jobStatus;
  }
  if (jobStatus === "Duplicate") {
    return "Duplicate Candidate";
  }
  if (interviewConfirmed) {
    return `${jobStatus} for`;
  }
  return `${jobStatus} on`;
};

const InterviewStatus = ({ lastAction, jobStatus, interviewConfirmed }) => (
  <InterviewStatusWrapper>
    <Status>{decorateJobStatus(jobStatus, interviewConfirmed)}</Status>
    <LastChange>{lastAction}</LastChange>
  </InterviewStatusWrapper>
);

InterviewStatus.propTypes = {
  lastAction: PropTypes.string,
  jobStatus: PropTypes.string.isRequired,
  interviewConfirmed: PropTypes.bool.isRequired,
};

InterviewStatus.defaultProps = {
  lastAction: PropTypes.isNull,
};

export default React.memo(InterviewStatus);
